import actions from './actions';

const {
  REQUIREMENT_ADD_BEGIN,
  REQUIREMENT_ADD_SUCCESS,
  REQUIREMENT_ADD_ERR,

  REQUIREMENT_READ_BEGIN,
  REQUIREMENT_READ_SUCCESS,
  REQUIREMENT_READ_ERR,

  REQUIREMENT_UPDATE_BEGIN,
  REQUIREMENT_UPDATE_SUCCESS,
  REQUIREMENT_UPDATE_ERR,
} = actions;

const initialState = {
  data: [],
  url: null,
  fileLoading: false,
  loading: false,
  error: null,
};

const addinitialState = {
  data: [],
  url: null,
  fileLoading: false,
  loading: false,
  error: null,
};

const updateinitialState = {
  data: [],
  url: null,
  fileLoading: false,
  loading: false,
  error: null,
};

const REQUIREMENTADDReducer = (state = addinitialState, action) => {
  const { type, data, err } = action;
  switch (type) {
    case REQUIREMENT_ADD_BEGIN:
      return {
        ...state,
        loading: true,
      };

    case REQUIREMENT_ADD_SUCCESS:
      return {
        ...state,
        data,
        error: false,
        loading: false,
      };

    case REQUIREMENT_ADD_ERR:
      return {
        ...state,
        error: err,
        loading: false,
      };

    default:
      return state;
  }
};

const REQUIREMENTUPDATEReducer = (state = updateinitialState, action) => {
  const { type, data, err } = action;
  switch (type) {
    case REQUIREMENT_UPDATE_BEGIN:
      return {
        ...state,
        loading: true,
      };

    case REQUIREMENT_UPDATE_SUCCESS:
      return {
        ...state,
        data,
        error: false,
        loading: false,
      };

    case REQUIREMENT_UPDATE_ERR:
      return {
        ...state,
        error: err,
        loading: false,
      };

    default:
      return state;
  }
};

const REQUIREMENTReducer = (state = initialState, action) => {
  const { type, data, err } = action;
  switch (type) {
    case REQUIREMENT_READ_BEGIN:
      return {
        ...state,
        loading: true,
      };

    case REQUIREMENT_READ_SUCCESS:
      return {
        ...state,
        data,
        error: false,
        loading: false,
      };

    case REQUIREMENT_READ_ERR:
      return {
        ...state,
        error: err,
        loading: false,
      };

    default:
      return state;
  }
};

export { REQUIREMENTADDReducer, REQUIREMENTReducer, REQUIREMENTUPDATEReducer };
